module.exports = {"开发指南":[{"name":"giud","path":"/giud","desc":"介绍"},{"path":"/base","desc":"基础","items":[{"name":"start","path":"/start","desc":"起步"},{"name":"installation","path":"/installation","desc":"安装"},{"name":"concept","path":"/concept","desc":"概念"},{"name":"watcher","path":"/watcher","desc":"watcher"}]},{"path":"/fineui","desc":"fineui集成","items":[{"name":"compact","path":"/compact","desc":"基本用法"},{"name":"context","path":"/context","desc":"context"},{"name":"mixins","path":"/mixins","desc":"mixins"}]},{"name":"index","path":"/","type":"pages"},{"name":"demo","path":"/demo","desc":"示例"}]}


//////////////////
// WEBPACK FOOTER
// ./client/nav.config.json
// module id = 9
// module chunks = 3